export const parseJwt = ({ token }) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

export const visitorTokenExpired = ({ token }) => {
  const jwt = parseJwt({ token });
  const utcTs = parseInt(jwt.exp, 10) * 1000;
  const currentTs = +new Date();
  return Boolean(utcTs < currentTs);
};

export const visitorAndClientTokenMatchUserId = ({ visitorToken, clientToken }) => {
  try {
    const visitorTokenData = parseJwt({ token: visitorToken });
    const clientTokenData = parseJwt({ token: clientToken });

    const visitorTokenUserId = visitorTokenData && visitorTokenData.user_id;
    const clientTokenUserId = clientTokenData && clientTokenData.user_id;

    return Boolean(
      visitorTokenUserId &&
      clientTokenUserId &&
      String(clientTokenUserId) === String(visitorTokenUserId)
    );

  } catch (e) { /* if one or both of the tokens is invalid(null) and cannot be parsed, we cannot compare user_id */ }

  return true;
};

export const getJwtBodyPart = ({ token }) => {
  try {
    return token.split('.')[1];
  } catch (e) {
    return e.message
  };
};
